<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 32 32"
>
  <circle
    [attr.stroke]="color"
    cx="16"
    cy="16"
    r="15"
    stroke-width="2"
  />
  <path
    [attr.fill]="color"
    d="M15 14C15 13.4477 15.4477 13 16 13C16.5523 13 17 13.4477 17 14V22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22V14Z"
  />
  <path
    [attr.fill]="color"
    d="M15.9999 7C15.0799 7 14.3333 7.74667 14.3333 8.66667C14.3333 9.58667 15.0799 10.3333 15.9999 10.3333C16.9199 10.3333 17.6666 9.58667 17.6666 8.66667C17.6666 7.74667 16.9199 7 15.9999 7Z"
  />
</svg>
